// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_ADD_POST = "pridanie diskusie";
export const ADD_FEED_POST = "Pridaj diskusiu";
export const COUNSELLING_IS_ARCHIVED = "Porad\u0148a je uzavret\u00e1";
export const FORUM_ADD_CONTEST = "Pridaj s\u00fa\u0165a\u017e";
export const FORUM_ADD_QUESTION = "Polo\u017e anonymn\u00fa ot\u00e1zku";
export const FORUM_POST_ADMINCLUB_MENU = "Adminclub";
export const FORUM_REPORTED_POSTS = "Nahl\u00e1sen\u00e9 pr\u00edspevky";
export const FORUM_TOPIC_DELETE = "Zma\u017e";
export const FORUM_TOPIC_EDIT = "Uprav popis a fotku";
export const FORUM_TOPIC_SEO_WITH_AI = "Skontroluj diskusie s AI";
export const SEO_DESCRIPTION_FORUM_topic = "V\u0161etko o t\u00e9me %(topic)s, \u010do mami\u010dky zauj\u00edma. Miesto pln\u00e9 sk\u00fasenost\u00ed, r\u00e1d, tipov a trikov priamo z prvej ruky.";
export const SEO_TITLE_FORUM = "F\u00f3ra";
export const TO_action_YOU_HAVE_TO_BE_loggedIn = "Pre %(action)s mus\u00ed\u0161 %(loggedIn)s.";
export const TO_BE_LOGGED_IN = "by\u0165 prihl\u00e1sen\u00e1";
